import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useEffectOnce } from 'react-use';

import { queuesApi } from 'apis/queues';
import { websocketActions } from 'app/middleware/websocket/actions/websocket';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppPathParams } from 'utils/url/useAppPathParams';

import { TvDashboardViewOutletContext } from '../../tvDashboard.view';
import { useTvDashboardReloadEffect } from '../../utils/useTvDashboardReloadEffect';

import { TvQueueDashboardMetrics } from './components/metrics/tvQueueDashboardMetrics';

export const TvQueueDashboardView = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const { queueId } = useAppPathParams('/tv/dashboard/:queueId');
  const { setTitle } = useOutletContext<TvDashboardViewOutletContext>();

  const { queue, isLoading } = queuesApi.useReadQueueQuery(
    { id: queueId },
    {
      selectFromResult: ({ data, ...rest }) => ({
        ...rest,
        queue: data?.data,
      }),
    },
  );

  useEffect(() => {
    if (queue) {
      setTitle(queue.name);
    }
  }, [queue, setTitle]);

  useEffectOnce(() => {
    dispatch(
      websocketActions.request({
        type: 'connection:subscribe',
        params: {
          type: 'real_time_dashboard',
          dashboard_type: 'queue',
        },
      }),
    );

    return () => {
      dispatch(
        websocketActions.request({
          type: 'connection:unsubscribe',
          params: {
            type: 'real_time_dashboard',
            dashboard_type: 'queue',
          },
        }),
      );
    };
  });

  useTvDashboardReloadEffect('queue');

  return <TvQueueDashboardMetrics queueId={queueId} isLoading={isLoading} />;
};
